import styled from '@emotion/styled'
import { breakpoint, calcRem, fonts } from '../../../__styling'

export const StyledWardenTitle = styled('h1')(({ theme }) => [
    {
        fontFamily: theme.fonts.heading,
        fontWeight: 700,
        color: theme.colors.text.heading,

        // Mobile styling
        fontSize: calcRem(40),
        lineHeight: calcRem(48),
        letterSpacing: calcRem(-1.6),

        // Anything bigger than mobile styling
        [breakpoint('xxs')]: {
            fontSize: calcRem(45),
            lineHeight: calcRem(48),
            letterSpacing: calcRem(-1.8),
        },
        // Anything bigger than laptop styling
        [breakpoint('lg')]: {
            fontSize: calcRem(51),
            lineHeight: calcRem(56),
            letterSpacing: calcRem(-2.04),
        },
    },
    // PerthNow styling
    theme.kind === 'perthnow' && {
        fontSize: calcRem(36),
        lineHeight: calcRem(40),
        letterSpacing: 0,

        // Anything bigger than mobile styling
        [breakpoint('xxs')]: {
            fontSize: calcRem(36),
            lineHeight: calcRem(40),
            letterSpacing: 0,
        },

        // Anything bigger than laptop styling
        [breakpoint('lg')]: {
            fontSize: calcRem(36),
            lineHeight: calcRem(40),
            letterSpacing: 0,
        },
    },
])
StyledWardenTitle.displayName = 'StyledWardenTitle'
